module.exports = __webpack_public_path__ + "img/scx.c61da3f7.png";